import { render, staticRenderFns } from "./avatar.vue?vue&type=template&id=5a7f4ea4&scoped=true&"
import script from "./avatar.vue?vue&type=script&lang=js&"
export * from "./avatar.vue?vue&type=script&lang=js&"
import style0 from "./avatar.vue?vue&type=style&index=0&id=5a7f4ea4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a7f4ea4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5a7f4ea4')) {
      api.createRecord('5a7f4ea4', component.options)
    } else {
      api.reload('5a7f4ea4', component.options)
    }
    module.hot.accept("./avatar.vue?vue&type=template&id=5a7f4ea4&scoped=true&", function () {
      api.rerender('5a7f4ea4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/event1/components/rolls/components/avatar.vue"
export default component.exports